/* HG Home — gedrag voor de nieuwe homepage-secties */
(function () {
  if (window.__hgxHome) return; window.__hgxHome = true;
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  function hero(root) {
    root.querySelectorAll('[data-hgx-hero]').forEach(function (h) {
      if (!once(h, 'hgxInit')) return;
      var s = h.querySelectorAll('.slide'), d = h.querySelectorAll('.dots button'), c = 0, t;
      if (s.length < 2) return;
      function go(i) { c = (i + s.length) % s.length; s.forEach(function (x, j) { x.classList.toggle('on', j === c); }); d.forEach(function (x, j) { x.classList.toggle('on', j === c); }); }
      function run() { clearInterval(t); t = setInterval(function () { go(c + 1); }, 6500); }
      d.forEach(function (b, j) { b.addEventListener('click', function () { go(j); run(); }); });
      var tx = null;
      h.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) { go(c + (dx < 0 ? 1 : -1)); run(); } tx = null; }, { passive: true });
      run();
    });
  }

  function tabs(root) {
    root.querySelectorAll('[data-hgx-tabs]').forEach(function (sec) {
      if (!once(sec, 'hgxTabs')) return;
      var btns = sec.querySelectorAll('.tabs button');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.toggle('on', x === b); });
          sec.querySelectorAll('.track').forEach(function (tr) { tr.hidden = tr.dataset.tab !== b.dataset.tab; });
        });
      });
      sec.querySelectorAll('.arrows button').forEach(function (b) {
        b.addEventListener('click', function () {
          var tr = [].slice.call(sec.querySelectorAll('.track')).filter(function (x) { return !x.hidden; })[0];
          if (tr) tr.scrollBy({ left: tr.clientWidth / 2 * Number(b.dataset.dir), behavior: 'smooth' });
        });
      });
    });
  }

  function cards(root) {
    root.querySelectorAll('.hgx .card[data-v]').forEach(function (card) {
      if (!once(card, 'hgxCard')) return;
      var vs; try { vs = JSON.parse(card.dataset.v); } catch (e) { return; }
      var main = card.querySelector('.main'), alt = card.querySelector('.alt'), cn = card.querySelector('.cn');
      card.querySelectorAll('.dot').forEach(function (d) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          var v = vs[Number(d.dataset.i)]; if (!v) return;
          card.querySelectorAll('.dot').forEach(function (x) { x.classList.toggle('on', x === d); });
          if (v.i && main) { main.src = v.i; main.removeAttribute('srcset'); }
          if (alt) { if (v.a) { alt.src = v.a; alt.removeAttribute('srcset'); alt.style.display = ''; } else { alt.style.display = 'none'; } }
          card.querySelectorAll('a').forEach(function (a) { a.href = v.h; });
          if (cn) cn.textContent = v.n + ' · ' + vs.length + ' ' + (card.dataset.colours || 'colours');
        });
      });
    });
  }

  function cta() {
    var m = document.querySelector('.hgx-cta'), h = document.querySelector('[data-hgx-hero]');
    if (!m || !h || m.dataset.hgxCta) return; m.dataset.hgxCta = '1';
    window.addEventListener('scroll', function () { m.classList.toggle('show', window.scrollY > h.offsetHeight); }, { passive: true });
  }

  function init(root) { hero(root); tabs(root); cards(root); cta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
